import type { Directive, DirectiveBinding } from 'vue';

const CAPTURE_INPUT_NAME_ATTRIBUTE = 'data-ph-capture-attribute-input-name';

const updateCaptureInputName = (el: HTMLElement, binding: DirectiveBinding<string | false | null | undefined>) => {
  if (!binding.value) {
    el.removeAttribute(CAPTURE_INPUT_NAME_ATTRIBUTE);
    return;
  }

  el.setAttribute(CAPTURE_INPUT_NAME_ATTRIBUTE, binding.value);
};

export const captureInputNameDirective: Directive<HTMLElement, string | false | null | undefined> = {
  mounted(el, binding) {
    updateCaptureInputName(el, binding);
  },
  updated(el, binding) {
    updateCaptureInputName(el, binding);
  },
};
